module.exports = __webpack_public_path__ + "img/my-profile.8502b91e.svg";